import {
	IAccountCameraSnapshot,
	ICameraPhotoStats,
	ICameraPreview
} from '@containers/monitoringPlatform/photoFixation/types'

const statsKey = (deviceId: number, cameraId: string, cameraCounter: number | null) =>
	`${deviceId}:${cameraId}:${cameraCounter ?? ''}`

const previewKey = (deviceId: number, cameraId: string) => `${deviceId}:${cameraId}`

const lastPhotoTime = (snapshot: IAccountCameraSnapshot) =>
	snapshot.cameras.reduce((max, camera) => {
		const time = camera.lastPhotoAt ? new Date(camera.lastPhotoAt).getTime() : 0
		return time > max ? time : max
	}, 0)

export const mergeCameraSnapshots = (
	devices?: IAccountCameraSnapshot[],
	stats?: ICameraPhotoStats[],
	previews?: ICameraPreview[]
): IAccountCameraSnapshot[] => {
	if (!devices?.length) {
		return []
	}

	const statsByKey = new Map(
		(stats ?? []).map((item) => [statsKey(item.deviceId, item.cameraId, item.cameraCounter), item])
	)
	const previewByKey = new Map(
		(previews ?? []).map((item) => [previewKey(item.deviceId, item.cameraId), item.previewUrl])
	)

	const merged = devices.map((device) => ({
		...device,
		cameras: device.cameras.map((camera) => {
			const cameraStats = statsByKey.get(statsKey(device.deviceId, camera.cameraId, camera.cameraCounter))
			return {
				...camera,
				previewUrl: previewByKey.get(previewKey(device.deviceId, camera.cameraId)) ?? null,
				lastPhotoAt: cameraStats?.lastPhotoAt ?? null,
				monthPhotos: cameraStats?.monthPhotos ?? 0,
				todayPhotos: cameraStats?.todayPhotos ?? 0,
			}
		})
	}))

	if (!stats?.length) {
		return merged
	}

	return merged
		.map((snapshot, index) => ({snapshot, index, time: lastPhotoTime(snapshot)}))
		.sort((a, b) => b.time - a.time || a.index - b.index)
		.map(({snapshot}) => snapshot)
}
